import * as yup from 'yup'
export const vCardSchema = yup.object().shape({
    name: yup.string().required('Chưa nhập tên'),
    email: yup.string().required('Chưa nhập email').email('Email sai format'),
    position: yup.string().required('Chưa có thông tin chức vụ'),
    phone: yup.string().required('Chưa có thông tin số điện thoại'),
    avatar: yup.string().required('Chưa có ảnh đại diện'),
    address: yup.string().required('Chưa có thông tin địa chỉ'),
    socials: yup.array().of(
        yup.object().shape({
            key: yup.string().required('Chưa có thông tin nền tảng'),
            value: yup.string().required('Chưa có thông tin liên kết'),
        })
    ),
})
